export const FORM_ERROR_CLASSNAME = 'error-field'; // for scroll on error

export const ALERT_CLASSNAME = 'alert'; // for scroll on error

export const CLASS_NAMES = {
  FORM_ERROR_CLASSNAME,
  ALERT_CLASSNAME,
} as const;
